<div id="loading-js" *ngIf="muestraLoading == true" class="loading-js">
    <div class="loader">
        <img class="" src="./assets/img/loader.svg" width="60" alt="">
    </div>
</div>


<div id="linea_exterior_step"></div>

<mat-horizontal-stepper [@.disabled]="true" [linear]="true" [disableRipple]="true" labelPosition="bottom" #stepper="matHorizontalStepper" class="row" (selectionChange)="onStepChange($event)">
    <ng-template matStepperIcon="edit" let-index="index">{{index + 1}}</ng-template>
    <app-modal-save></app-modal-save>
    <div *ngIf="router != '/amena/solo_movil'">
        <mat-step [stepControl]="firstFormGroup" [editable]="!isEditable" label="Fijo" state="number">
            <div class="container content">
                <div class="row">
                    <div class="col-md-8 offset-md-2 pb-5">
                        <div *ngIf="!clientIsCover">
                            <div class="alert alert-success-blue alert-list mb-3" role="alert">
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                    <img src="./assets/img/times2.svg" width="23" class="ms-2">
                                </button>
                            </div>
                            <app-customer [formGroup]="customerFormGroup" *ngIf="!environment.production"></app-customer>
                        </div>
                        <div *ngIf="clientIsCover">
                            <h5 class="title-step" align="center">
                                <img src="./assets/img/map-pin.svg" class="img-fluid ico-title" width="20">
                                Dirección de instalación
                            </h5>
                            <div class="jumbotron-norm" style="margin-bottom: 4rem!important;" *ngIf="muestraNormalizacion">
                                <form [formGroup]="firstFormGroup">
                                    <app-normaliza-direccion [(formGroup)]="firstFormGroup"></app-normaliza-direccion>
                                    <app-cobertura [(formGroup)]="firstFormGroup" *ngIf="!migrationData || (migrationData && !migrationData.migrationFibra)"></app-cobertura>
                                    <app-cobertura-migration [(formGroup)]="firstFormGroup" *ngIf="migrationData && migrationData.migrationFibra"></app-cobertura-migration>
                                </form>
                            </div>
                            <div *ngIf="!muestraNormalizacion">
                                <div id="Errores_ninguna" *ngIf="muestraErrorPeticion">
                                    <mat-error>
                                        <p class="alert alert-warning bg-green text-center" style="display: flex; flex-wrap: wrap;" [innerHTML]="msgErrorPeticion"></p>
                                    </mat-error>
                                </div>
                                <app-resultado class="amena" [(resultFormGroup)]="firstFormGroup"></app-resultado>
                            </div>
                        </div>
                    </div>
                </div>
                <app-rate [realtechnology]="realtechnology" [listener]="this" *ngIf="!muestraNormalizacion && !msgErrorPeticion && clientIsCover && rate == null"></app-rate>
                <app-landline-configuration [listener]="this" [rate]="rate" (editRateParent)="editRate()" *ngIf="rate && clientIsCover"></app-landline-configuration>
            </div>
        </mat-step>
    </div>

    <mat-step [stepControl]="mobilePack.secondFormGroup" *ngFor="let mobilePackForm of secondFormGroup.controls.form.value; let i = index"
              label="{{ i == 0 ? 'Móvil principal' : (i + 1) + 'º linea móvil' }}" [editable]="!isEditable" state="number">
        <app-customer [formGroup]="customerFormGroup" *ngIf="!clientIsCover && !environment.production"></app-customer>
        <app-mobile-pack #mobilePack
                         [index]="i"
                         [amenaListener]="this"
                         [stepperChild]="stepper"
                         [hidden]="!clientIsCover">
        </app-mobile-pack>
    </mat-step>

    <mat-step label="Cliente" state="number" [editable]="!isEditable" [completed]="isUserValidation">
        <form [formGroup]="thirdFormGroup">
            <app-user-data [(formGroup)]="thirdFormGroup"></app-user-data>
        </form>
    </mat-step>

    <mat-step label="Confirmación" state="number" [editable]="!isEditable">
        <form [formGroup]="fourthFormGroup">
            <app-confirmation [stepper]="stepper"></app-confirmation>
        </form>
    </mat-step>
</mat-horizontal-stepper>

